export default __webpack_public_path__ + "img/14.688032.png";